import {combineReducers} from 'redux';

import auth from './auth';
import theme from './theme';
import moduleRedux from './module';

const reducers = combineReducers({theme, auth, moduleRedux});

export default reducers;
